/**
 * 목록 페이지의 **순수 판정.**
 *
 * 이 파일은 순수 판정만 든다 — DOM 없이 `tsx --test` 로 검사하기 위해서다. 훅과
 * 라우터는 `list-page.tsx` 에 있고, 그쪽은 vitest 가 본다. 아래 둘은 이 화면들에서
 * **실측으로 틀렸던 자리**라 테스트가 붙어야 한다.
 */
/** 기본 파라미터 이름. 한 화면에 목록이 둘이면 `param` 으로 가른다. */
export const DEFAULT_OFFSET_PARAM = 'offset';

/**
 * URL 의 offset. 음수·소수·문자·빈 값은 전부 0 이다.
 *
 * 서버(`resolvePage`)도 같은 입력을 기본값으로 되돌린다. 여기서 조용히 고치는 것이 아니라
 * **같은 규칙을 적용**하는 것이다 — 클라이언트가 `-1` 을 그대로 보내면 서버가 0 으로 읽고,
 * 그러면 URL 과 화면이 어긋난 채로 남는다.
 */
export function toOffset(raw: string | null): number {
  const n = Number(raw);
  return Number.isInteger(n) && n > 0 ? n : 0;
}

export interface RangeInput {
  readonly offset: number;
  /** 검색어. 있으면 "결과 없음"이지 "범위 밖"이 아니다. */
  readonly q: string;
  /** 응답이 왔다면 행 수, 아직/실패면 undefined. */
  readonly rowCount?: number;
  /** 실패했다면 그 실패가 가리키는 필드(`details.field`). */
  readonly failedField?: string;
}

/**
 * **범위 밖 페이지인가.** 두 경로가 한 답으로 모인다:
 *  ① 상한 안이지만 데이터의 끝을 넘었다 → 200 + 빈 목록
 *  ② 상한(`maxOffset`)을 넘었다 → 422 (`details.field === 'offset'`)
 *
 * 실측(2026-09-02): ①이 "아직 등록된 직원이 없습니다"로 그려졌는데 실제로는 63명이 있었다.
 * 첫 페이지(`offset === 0`)의 빈 목록은 **진짜 빈 회사**이므로 여기서 제외된다 —
 * 그 둘을 합치면 신규 회사에 "페이지 번호가 범위를 벗어났습니다"라고 말하게 된다.
 */
export function isOutOfRange(input: RangeInput): boolean {
  if (input.offset <= 0) return false;
  if (input.failedField === 'offset') return true;
  return input.rowCount === 0 && input.q === '';
}
